import { FormEvent, useState } from "react";
import { parseRiotId } from "../api";

interface SearchFormProps {
  initialValue?: string;
  loading?: boolean;
  compact?: boolean;
  onSearch: (gameName: string, tagLine: string) => void;
}

export function SearchForm({ initialValue = "", loading = false, compact = false, onSearch }: SearchFormProps) {
  const [value, setValue] = useState(initialValue);
  const [error, setError] = useState("");

  function runSearch() {
    const parsed = parseRiotId(value);
    if (!parsed) {
      setError("Use the format GameName#Tag, for example ImOscios#NA1.");
      return;
    }
    setError("");
    onSearch(parsed.gameName, parsed.tagLine);
  }

  function submit(event: FormEvent) {
    event.preventDefault();
    runSearch();
  }

  return (
    <form className={`search-form ${compact ? "search-form--compact" : ""}`} onSubmit={submit} noValidate>
      <div className="search-field-wrap">
        <label htmlFor={compact ? "riot-id-compact" : "riot-id"}>Riot ID</label>
        <input
          id={compact ? "riot-id-compact" : "riot-id"}
          value={value}
          onChange={(event) => { setValue(event.target.value); if (error) setError(""); }}
          placeholder="ImOscios#NA1"
          autoComplete="off"
          autoCapitalize="none"
          spellCheck={false}
          onKeyDown={(event) => { if (event.key === "Enter") { event.preventDefault(); runSearch(); } }}
          aria-invalid={Boolean(error)}
          aria-describedby={error ? "search-error" : undefined}
          disabled={loading}
        />
        {!compact && <span className="input-hint">NAME<span>#</span>TAG</span>}
      </div>
      <button className="search-button" type="submit" disabled={loading}>
        {loading ? <><span className="spinner" aria-hidden="true" />Searching</> : <>Search<span aria-hidden="true">↗</span></>}
      </button>
      {error && <p className="form-error" id="search-error" role="alert">{error}</p>}
    </form>
  );
}
